<template>
	<div class="set-has-keywords-item">
		<el-form ref="form" :model="form" :rules="formRules" label-width="120px">
			<el-form-item label="规则名称：" prop="name">
				<el-input placeholder="请输入规则名称" v-model="form.name" clearable>
				</el-input>
			</el-form-item>
			<el-form-item v-for="(item, index) in form.keywords" label="关键词" :key="'keywords.' + index"
				:prop="'keywords.' + index + '.keysValue'" :rules="{
			      required: true, message: '请输入关键词', trigger: 'blur'
			    }">
				<el-input placeholder="请输入内容" v-model="item.keysValue" style="width:80%" maxlength="30" show-word-limit>
					<el-select v-model="item.matchType" slot="prepend" placeholder="请选择" style="width: 100px;">
						<el-option label="半匹配" value="1"></el-option>
						<el-option label="全匹配" value="2"></el-option>
					</el-select>
				</el-input>
				<div style="display: inline-block;margin-left: 5px;">
					<el-button type="text" @click.prevent="addKeywords(item,index)" v-show="active_keywords == index">添加</el-button>
					<el-button type="text" @click.prevent="removeKeywords(item,index)" v-show="form.keywords.length > 1">删除</el-button>
				</div>
			</el-form-item>
			<el-form-item v-for="(item, index) in form.contents" label="回复内容" :key="'contents.' + index"
				:prop="'contents.' + index + '.response'" :rules="{
			      required: true, message:item.responseType =='text'?'请输入回复内容':'请选择', trigger: item.responseType =='text'? 'blur' :'change'
			    }">
				<el-select v-model="item.responseType" placeholder="请选择" style="width: 100px;display: block;" @change="(val) => onResponseType(val,index)">
					<el-option label="文本" value="text"></el-option>
					<el-option label="IM" value="im" :disabled="getDisabled"></el-option>
				</el-select>
				<template v-if="item.responseType == 'text'">
					<el-input placeholder="请输入回复内容" type="textarea" v-model="item.response" style="width:80%;margin-top: 5px;" maxlength="300" show-word-limit></el-input>
				</template>
				<template v-else>
					<div style="margin-top: 10px;" v-show="!item.response">
						<el-select v-model="form.brand" clearable placeholder="请选择授权品牌" @change="onBrandChange">
							<el-option v-for="item in brand_options" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
					<div style="margin-top: 10px;" v-show="!item.response">
						<el-select v-model="form.skillGroup" clearable placeholder="请选择技能组">
							<el-option v-for="item in skillGroup_options" :key="item.skillId" :label="item.skillName"
								:value="item.skillId">
							</el-option>
						</el-select>
					</div>
					<el-input style="margin-top: 10px;" v-model="item.response" @focus="onFocusResponse(item)" v-show="item.response"></el-input>
				</template>
				<div style="display: inline-block;margin-left: 5px;">
					<el-button type="text" @click.prevent="addContents(item,index)" v-show="active_contents == index">添加</el-button>
					<el-button type="text" @click.prevent="removeContents(item,index)" v-show="form.contents.length > 1">删除</el-button>
				</div>
			</el-form-item>
			<el-collapse >
				  <el-collapse-item title="高级属性" name="1">
					<el-form-item label="服务名：" prop="serviceName">
						<el-input placeholder="请输入服务名" v-model="form.serviceName" clearable>
						</el-input>
					</el-form-item>
					<el-form-item label="方法名：" prop="waysName">
						<el-input placeholder="请输入方法名" v-model="form.waysName" clearable>
						</el-input>
					</el-form-item>
				  </el-collapse-item>
			  </el-collapse>
		</el-form>
		<div class="dialog-footer" style="text-align: right;">
			<el-button @click="onBack" size="mini">取 消</el-button>
			<el-button type="primary" size="mini" @click="onSave" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}
			</el-button>
		</div>
	</div>
</template>

<script>
	import {mapGetters} from 'vuex'
	export default {
		computed:{
			 ...mapGetters([
				'subBrandList',
			]),
			getDisabled(){
				const index = this.form.contents.findIndex((el) => el.responseType == 'im');
				if(index == -1) return false
				 return true
			}
		},
		inject:['row_data'],
		props:['row_subs'],
		data() {
			return {
				dialogVisible: false,
				loading: false,
				form: {
					name: '',
					skillGroup: '',
					brand: '',
					keywords: [{
						keysValue: '',
						matchType: '1',
						orderno:0
					}],
					contents:[{
						orderno:0,
						response:'',
						responseType:'text',//im
					}],
					serviceName: '',
					waysName: ''
				},
				active_keywords:0,
				active_contents:0,
				formRules: {
					name: [{
						required: true,
						message: '请输入规则名称',
						trigger: 'blur'
					}]
				},
				skillGroup_options: [],
				brand_options: [],
			}
		},
		watch:{
			'row_subs':{
				handler(val){
					if(val){
						this.active_keywords = val.rulesKeyList ? JSON.parse(JSON.stringify(val.rulesKeyList)).length - 1 : 0;
						this.active_contents = val.rulesResponseList ? JSON.parse(JSON.stringify(val.rulesResponseList)).length - 1 : 0;
						this.form.name= val.rulename;
						this.form.keywords = val.rulesKeyList ? JSON.parse(JSON.stringify(val.rulesKeyList)) : [];
						this.form.contents = val.rulesResponseList ? JSON.parse(JSON.stringify(val.rulesResponseList)) : [];
						this.form.serviceName = val.service;
						this.form.waysName = val.method;
						
					}
				},
				deep:true,
				immediate:true
			},
			'form.skillGroup': {
				handler(val){
					const index = this.form.contents.findIndex((el) => el.responseType == 'im');
					if(val){
						this.form.contents[index].response = 'im内容';
					}else {
						this.form.contents[index].response = '';
					}
				},
				deep:true
			}
		},
		methods: {
			onSave() {
				 this.$refs['form'].validate((valid) => {
				  if (valid) {
					  this.loading = true;
					  if(this.row_subs){
						   this.getImContents(() => {
							   this.$api.editWechatSystemkeyword({
							   	appid: this.row_data.data.appid || this.row_data.data.id,
							   	id:this.row_subs.id,
							   	rulename:this.form.name,
							   	rulesKeyList:this.formatNum(this.form.keywords),
							   	rulesResponseList:this.formatNum(this.form.contents),
							   	service:this.form.serviceName,
							   	method: this.form.waysName,
							   }).then(res => {
								   this.loading = false;
									if(res.errcode == 0) {
										this.$message.success('编辑成功');
										this.$emit('getList')
									}
							   }).catch(err => {
									this.loading = false;
								})
						   })
						 
					  }else {
						  this.getImContents(() => {
							  this.$api.addWechatSystemkeyword({
								   appid: this.row_data.data.appid || this.row_data.data.id,
								   rulename:this.form.name,
								   rulesKeyList:this.formatNum(this.form.keywords),
								   rulesResponseList:this.formatNum(this.form.contents),
								   service:this.form.serviceName,
								   method: this.form.waysName,
							  }).then(res => {
								   this.loading = false;
									if(res.errcode == 0) {
									   this.$message.success('添加成功');
									   this.$emit('getList')
								   }
							  }).catch(err => {
									this.loading = false;
							  })
						  })
						 
					  }
				  }
				});
			},
			onBack(){
				this.$emit('onBack')
			},
			removeKeywords(row,index) {
				let difference = Math.abs(index - this.active_keywords);
				var index = this.form.keywords.indexOf(row)
				if (index !== -1) {
				  this.form.keywords.splice(index, 1)
				}
				if(difference == 1){
					this.active_keywords = index  < 0 ? 0 : index 
				}else {
					this.active_keywords = this.form.keywords.length - 1
				}
			},
			addKeywords(row,index) {
				this.active_keywords = index + 1
				 this.form.keywords.push({
					  keysValue: '',
					  matchType: '1',
				});
			},
			addContents(row,index){
				 this.active_contents = index + 1
				 this.form.contents.push({
					response:'',
					responseType:'text',
					
				});
			},
			removeContents(row,index){
				let difference = Math.abs(index - this.active_contents);
				var index = this.form.contents.indexOf(row)
				if (index !== -1) {
					  this.form.contents.splice(index, 1)
				}
				if(difference == 1){
					this.active_contents = index < 0 ? 0 : index 
				}else {
					this.active_contents = this.form.contents.length - 1
				}
				
			},
			formatNum(data){
				data.map((item,index) => {
					item.orderno = parseInt(index + 1)
				})
				return data
			},
			getSkillGroup(data){
				let result = [];
				this.$api.getWechatSystemSkillGroup({brand:data.appidConfig?.grantBrand,appid:data.appid}).then(res => {
					this.skillGroup_options = res.data;
					this.form.skillGroup = ''
				})
			},
			onBrandChange(val){
				if(val){
					this.row_data.data.appidConfig.grantBrand = val;
					this.getSkillGroup(this.row_data.data);
					
				}else{
					this.skillGroup_options = [];
					this.form.skillGroup = ''
				}
			},
			onResponseType(val,index){
				this.form.contents[index].response = '';
				if(val == 'im') {
					this.form.brand = '';
					this.form.skillGroup = ''
				}
			},
			getImContents(callback){
				const index = this.form.contents.findIndex((el) => el.responseType == 'im');
				if(index == -1) {
					callback()
				}else {
					this.$api.updateWechatSystemBasic({
						  "appid": this.row_data.data.appid,
						  "brand": this.form.brand,
						  "skillGroup": this.form.skillGroup,
						  "channel": this.row_data.data.type,
						  "sourceBrand": this.row_data.data.appidConfig.grantBrand,
						  "sourceSkillGroup": this.row_data.data.appidConfig.grantSkillgroup
					}).then(res => {
						if(res.errcode == 0) {
							if(index != -1) {
								this.form.contents[index].response = res.data.imUrl;
								callback()
							}
						}
					}).catch(err => {
						this.loading = false;
					})
				}
				
			},
			onFocusResponse(row){
				row.response = ''
			}
		},
		async mounted() {
			this.brand_options= await this.subBrandList;
			this.getSkillGroup(this.row_data.data)
		}
	}
</script>

<style lang="scss" scoped>
	.set-has-keywords-item {
		height: calc(100vh - 150px);
		overflow-y: scroll;
		.el-collapse {
			padding: 0 20px 20px 20px;
			border: none;
		}
	}
</style>
